module.exports = __webpack_public_path__ + "media/entities/79-d0e4fc70.png";